import gql from 'graphql-tag';
import threadParticipantFragment from '../thread/threadParticipant';

export default gql`
  fragment messageInfo on Message {
    id
    timestamp
    modifiedAt
    messageType
    bot
    parent {
      id
      timestamp
      messageType
      author {
        ...threadParticipant
      }
      content {
        body
      }
    }
    author {
      ...threadParticipant
    }
    reactions {
      count
      hasReacted
    }
    content {
      body
    }
    reply {
      id
      timestamp
      messageType
      parent {
        id
        timestamp
        messageType
        author {
          ...threadParticipant
        }
        content {
          body
        }
      }
      author {
        ...threadParticipant
      }
      content {
        body
      }
      reactions {
        count
        hasReacted
      }
      mentionUser {
        ...threadParticipant
      }
    }
    mentionUser {
      ...threadParticipant
    }
  }
  ${threadParticipantFragment}
`;
